import React from 'react';

import { Label, DeliveryCategory } from '~api/api';

import { Separator } from '~src/main/ui/separator';
import { useFreeShippingLabels } from '../free-shipping';
import { LabelComponent } from './label-component';
import { SwanLabelComponent } from './swan-label-component';

const labelSortFunction = (a: Label, b: Label): number => {
  return (
    Number(b.type === 'LABEL_TYPE_SUSTAINABILITY') - Number(a.type === 'LABEL_TYPE_SUSTAINABILITY')
  );
};

interface LabelExtensionProps {
  category: DeliveryCategory;
}

export const LabelExtension: React.FC<LabelExtensionProps> = ({ category }) => {
  const freeShippingLabels = useFreeShippingLabels(category);

  const labels = [...(category.active_labels ?? []), ...freeShippingLabels];

  if (labels.length === 0) {
    return null;
  }

  const sortedLabels = Array.from(labels).sort(labelSortFunction);

  const labelElements = sortedLabels.map((label: Label, idx: number) =>
    label.type === 'LABEL_TYPE_SWAN' ? (
      <SwanLabelComponent key={idx} />
    ) : (
      <LabelComponent
        key={idx}
        categoryName={category.name}
        sortedLabels={sortedLabels.filter(label => label.type !== 'LABEL_TYPE_SWAN')}
        label={label}
      />
    )
  );

  return <Separator>{labelElements}</Separator>;
};
